import { render, staticRenderFns } from "./SupplementDetail.vue?vue&type=template&id=a6e48880&scoped=true&"
import script from "./SupplementDetail.vue?vue&type=script&lang=js&"
export * from "./SupplementDetail.vue?vue&type=script&lang=js&"
import style0 from "./SupplementDetail.vue?vue&type=style&index=0&id=a6e48880&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e48880",
  null
  
)

export default component.exports